import { ValidDateFormat } from '@Types';
import { DateTime } from 'luxon';

export const getValidDateFormat = (
	dateString: string,
): ValidDateFormat | undefined => {
	if (DateTime.fromFormat(dateString, 'L/d/yy H:m').isValid)
		return 'L/d/yy H:m';
	if (DateTime.fromFormat(dateString, 'LL/dd/yyyy HH:mm:ss').isValid)
		return 'LL/dd/yyyy HH:mm:ss';
	if (DateTime.fromFormat(dateString, 'yyyy/LL/dd HH:mm:ss').isValid)
		return 'yyyy/LL/dd HH:mm:ss';
	if (DateTime.fromFormat(dateString, 'yyyy-LL-dd HH:mm:ss').isValid)
		return 'yyyy-LL-dd HH:mm:ss';
	return undefined;
};
